import { DictionaryCategory, DictionaryCategorySchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";

export type PatchCategoryMappingRequest = {
	categoriesMapping: ItemMapping;
}

export type PatchCategoryMappingResponse = {
	dictionaryCategories: DictionaryCategory[];
};

export const patchCategoryMapping = createAppAsyncThunk<PatchCategoryMappingResponse, PatchCategoryMappingRequest>(
	"patchCategoryMapping",
	async ({ categoriesMapping }, { extra, getState, rejectWithValue }) => {

		const { extractCategories, dictionaryCategories } = getState().etlData;

		const tmpDictionaryCategories = [...dictionaryCategories];

		const extractCategory = extractCategories.find((extractCategory) => extractCategory.id === categoriesMapping.extractId);
		const dictionnaryCategory = dictionaryCategories.find((dictionaryCategory) => dictionaryCategory.id === categoriesMapping.dicoId);

		if (
			dictionnaryCategory?.hb_category_id === extractCategory?.hb_id
			&& dictionnaryCategory?.hb_category_libelle === extractCategory?.libelle
		) {
			return rejectWithValue("No changes");
		}

		if (extractCategory && dictionnaryCategory) {
			const dictionaryCategorysUpdated = await extra.etlClient.update(
				DictionaryCategorySchema,
				dictionnaryCategory.id,
				{
					hb_category_id: extractCategory?.hb_id,
					hb_category_libelle: extractCategory?.libelle
				},
			);

			if (dictionaryCategorysUpdated) {
				tmpDictionaryCategories.splice(
					tmpDictionaryCategories.findIndex((category) => category.id === categoriesMapping.dicoId),
					1,
					dictionaryCategorysUpdated.data
				);
			}

		}
		return {
			dictionaryCategories: tmpDictionaryCategories
		}
	}
);
